





import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Token extends Vue {
  get token(): string {
    return this.$store.getters.getUser.token;
  }
}
